import { render, staticRenderFns } from "./Paso1.vue?vue&type=template&id=6581e95a&lang=pug"
import script from "./Paso1.vue?vue&type=script&lang=js"
export * from "./Paso1.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports